module.exports = __webpack_public_path__ + "static/media/chevron-thin-down.ffd002cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chevron-thin-down.svg
// module id = 98
// module chunks = 0